import React from "react";
import { Container } from "./Container";

// w/h = intrinsic asset dimensions (explicit width/height attributes let the
// browser reserve the box before the file arrives — no layout shift).
const BRANDS = [
  { slug: "canadian-solar", name: "Canadian Solar", src: "/brands/canadian-solar.webp", w: 340, h: 64 },
  { slug: "ja-solar", name: "JA Solar", src: "/brands/ja-solar.svg", w: 453, h: 80 },
  { slug: "tindo-solar", name: "Tindo Solar", src: "/brands/tindo-solar.svg", w: 135, h: 60 },
  { slug: "risen-energy", name: "Risen Energy", src: "/brands/risen-energy.svg", w: 638, h: 219 },
  { slug: "sungrow", name: "Sungrow", src: "/brands/sungrow.svg", w: 1552, h: 340 },
  { slug: "fronius", name: "Fronius", src: "/brands/fronius.webp", w: 340, h: 170 },
  { slug: "goodwe", name: "GoodWe", src: "/brands/goodwe.svg", w: 767, h: 114 },
  { slug: "alpha-ess", name: "Alpha ESS", src: "/brands/alpha-ess.svg", w: 196, h: 67 },
];

const Logo = ({ b }) => (
  <div
    className="brand-slot inline-flex items-center justify-center w-24 md:w-32 h-12 shrink-0"
    data-testid={`brand-logo-${b.slug}`}
  >
    <img
      src={b.src}
      alt={b.name}
      width={b.w}
      height={b.h}
      loading="lazy"
      draggable={false}
      className="brand-logo block h-12 max-h-12 w-auto object-contain select-none"
    />
  </div>
);

export const BrandsMarquee = () => (
  <section
    id="brands"
    data-testid="brands-section"
    className="bg-muted border-y border-border"
  >
    <Container className="py-16 md:py-20">
      <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
        <div className="qv-eyebrow text-brand-blue mb-4">Trusted equipment</div>
        <h2 className="qv-h2">We install leading brands.</h2>
      </div>

      <div
        className="brand-marquee relative overflow-hidden"
        data-testid="brands-marquee"
      >
        <div
          className="brand-track flex items-center gap-10 md:gap-14"
          aria-label="Leading solar brands we install"
        >
          {BRANDS.map((b) => (
            <Logo key={`a-${b.slug}`} b={b} />
          ))}
          {/* Duplicate set for seamless loop. */}
          {BRANDS.map((b) => (
            <Logo key={`b-${b.slug}`} b={{ ...b, slug: `${b.slug}-dup` }} />
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default BrandsMarquee;
